import { render } from "./SongsList.vue?vue&type=template&id=ba7f7088&scoped=true"
import script from "./SongsList.vue?vue&type=script&lang=js"
export * from "./SongsList.vue?vue&type=script&lang=js"

import "./songs.scss?vue&type=style&index=0&id=ba7f7088&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7f7088"]])

export default __exports__